import { cn } from "../lib/utils";
import React from "react";
import { Chip } from "./Chip";
import { DoubleIcon, Icon } from "./Icon";
const attachmentChipOverrides = cn("rounded-lg px-2 py-1 heading-sm gap-1.5", "bg-background text-foreground max-w-44", "align-middle");
export function AttachmentChip({ icon, doubleIcon, className, label, size, color, isBusy, onRemove, onClick, ...linkProps }) {
    const chipClassName = cn(attachmentChipOverrides, className);
    const iconElement = (icon || doubleIcon) && (React.createElement("div", { className: "shrink-0" }, doubleIcon ? React.createElement(DoubleIcon, { ...doubleIcon }) : React.createElement(Icon, { ...icon })));
    if ("href" in linkProps && linkProps.href) {
        return (React.createElement(Chip, { className: chipClassName, label: label, size: size, color: color, isBusy: isBusy, onRemove: onRemove, ...linkProps }, iconElement));
    }
    return (React.createElement(Chip, { className: chipClassName, label: label, size: size, color: color, isBusy: isBusy, onRemove: onRemove, onClick: onClick }, iconElement));
}
//# sourceMappingURL=AttachmentChip.js.map